<app-view-item
  *ngIf="disabled"
  [text]="displayText"
  [borderless]="borderless"
></app-view-item>

<nz-select
  *ngIf="!disabled"
  [(ngModel)]="value"
  [nzBorderless]="borderless"
  (ngModelChange)="onModelChange($event)"
  nzAllowClear="false"
  [nzDropdownMatchSelectWidth]="false"
>
  <nz-option
    [nzValue]="item.value"
    [nzLabel]="item.value + ' - ' + item.name"
    *ngFor="let item of options"
  ></nz-option>
</nz-select>
